/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createSackurTetrode } from '../../factoriesAny.js';
export var sackurTetrodeDependencies = {
  BigNumberDependencies,
  createSackurTetrode
};